import { brandSecondary } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {},
	footer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	header: {
		color: brandSecondary,
		fontSize: 18,
		marginBottom: 16,
	},
	input: {},
	inputs: {
		marginBottom: 20,
		...CssSelectors.allChildren(
			{
				marginTop: 10,
			},
			':not(:first-child)'
		),
	},
	modal: {},
});
